import { FC, useState } from 'react'
import TextTableFilter from '../../common/TextTableFilter'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'

export const PickupFeesReportFilters: FC = () => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useSearchParams()
    const [startDateFilter, setStartDateFilter] = useState(searchParams.get('filter_date_start') || '')
    const [endDateFilter, setEndDateFilter] = useState(searchParams.get('filter_date_end') || '')

    const handleChange = (id: string, value: string, type: string) => {
        if (value) {
            searchParams.set(id, value)
            searchParams.set('current_page', '1')
        } else {
            searchParams.delete(id)
        }
    }

    const clearFilters = (): void => {
        setSearchParams({}, {
            replace: true
        })
        setStartDateFilter('')
        setEndDateFilter('')
    }

    const filter = (): void => {
        setSearchParams(searchParams, {
            replace: true
        })
    }

    return (
        <>
            <div className='card-body border-bottom pb-10 mb-5'>
                <div className='row'>
                    <TextTableFilter
                        id='filter_date_start'
                        label={formatMessage({ id: "from" })}
                        value={startDateFilter}
                        setValue={setStartDateFilter}
                        onChange={handleChange}
                        delay={0}
                        type='date'
                    />
                    <TextTableFilter
                        id='filter_date_end'
                        label={formatMessage({ id: "to" })}
                        value={endDateFilter}
                        setValue={setEndDateFilter}
                        onChange={handleChange}
                        delay={0}
                        type='date'
                    />

                    <div className='col-sm-12 col-md-2'>
                        <button
                            className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
                            onClick={filter}
                        >
                            {formatMessage({ id: "filter" })}
                        </button>
                    </div>

                    <div className='col-sm-12 col-md-2'>
                        <button
                            type='reset'
                            className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
                            onClick={clearFilters}
                        >
                            {formatMessage({ id: "reset" })}
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}

export default PickupFeesReportFilters
